import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a money value for display, e.g. 16308 -> "£16,308.00".
 * Accepts numbers or the decimal strings the API returns; blank/NaN reads as 0.
 * Always use this on customer-facing totals — a bare toFixed(2) prints
 * "£16308.00", which is hard to read at a glance on a quote or invoice.
 */
export function money(value: number | string | null | undefined): string {
  const n = typeof value === "number" ? value : parseFloat(String(value ?? "0"))
  const safe = Number.isFinite(n) ? n : 0
  return `£${safe.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}
